import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import DocumentScoringIndicatorListRowComponent from './DocumentScoringIndicatorListRowComponent';
import { Button } from '@totalsoft/rocket-ui';
import { withRights } from 'providers/RightsConsumer';

// material-ui components
import { Box, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

const DocumentScoringIndicatorListComponent = ({
  indicatorList,
  periodList,
  onSaveFinancialIndicators,
  t,
  isValid,
  saving,
  disabled,
  handleFinancialIndicatorValueChange,
  isHistory,
  rights
}) => {
  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t('DocumentEdit.Scoring.ScoringIndicator.Indicator')}</TableCell>
            {periodList.length > 0 &&
              periodList
                .filter(period => period.selected)
                .map(period => (
                  <TableCell key={period.documentScoringFinancialIndicatorPeriodDimensionId}>
                    {period.dimensionId ? period.dimensionPeriodName + ' (' + period.dimensionName + ')' : period.dimensionPeriodName}
                  </TableCell>
                ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {indicatorList.length > 0 &&
            indicatorList.map(({ document }, idx) => {
              return (
                <DocumentScoringIndicatorListRowComponent
                  key={document.scoringFinancialIndicatorId}
                  idx={idx}
                  indicator={document}
                  periodList={periodList}
                  disabled={rights.readOnlyFull || saving || disabled || document.readOnly}
                  onFinancialIndicatorValueChange={handleFinancialIndicatorValueChange}
                />
              );
            })}
        </TableBody>
      </Table>

      {!isHistory && (
        <Box mt={1}>
          <Button
            color='primary'
            sx={{ marginTop: 1 }}
            disabled={rights.readOnlyFull || disabled || !indicatorList.some(x => x.dirtyInfo.isDirty) || saving || !isValid}
            onClick={onSaveFinancialIndicators}
          >
            {saving ? t('Saving') + '...' : t('Save')}
          </Button>
        </Box>
      )}
    </>
  );
};

DocumentScoringIndicatorListComponent.propTypes = {
  isValid: PropTypes.bool.isRequired,
  indicatorList: PropTypes.array.isRequired,
  periodList: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  handleFinancialIndicatorValueChange: PropTypes.func.isRequired,
  onSaveFinancialIndicators: PropTypes.func.isRequired,
  isHistory: PropTypes.bool.isRequired,
  rights: PropTypes.object.isRequired
};

export default compose(withTranslation())(withRights(DocumentScoringIndicatorListComponent));
